<template lang="pug">
    v-dialog#tax-dialog(v-model="value" scrollable persistent max-width=640 eager)
        v-card 
            v-card-title 
                .title {{editType==1? $t('Products.__AddNewProduct'): $t('Products.__EditProduct')}}
            v-card-text
                v-form.product-info(v-model="formValid", ref="productform")
                    .field-label 
                        span {{ $t('Products.__Name') }}
                        span.required *
                    v-text-field(
                        v-model="item.name",
                        solo,
                        dense,
                        outlined,
                        required,
                        :rules="[rules.required]"
                    )
                    .field-label 
                        span {{ $t('Products.__Memo') }}
                    v-textarea(
                        v-model="item.description",
                        solo,
                        outlined,
                        height="80"
                    )
                    .field-label 
                        span {{ $t('Products.__Price') }}
                        span.required *
                    v-text-field(
                        v-model.number="item.price",
                        solo,
                        dense,
                        outlined,
                        required,
                        :rules="[rules.required]",
                        type="number"
                    )
                    //- .field-label 
                    //-     span {{ $t('Products.__Sell') }}
                    //- v-checkbox(
                    //-     v-model="item.incomeTag",
                    //-     :label="$t('Products.__IsSellItem')"
                    //- )
                    .field-label(v-if="item.incomeTag") 
                        span {{ $t('Products.__IncomeAccount') }}
                        span.required *
                        //- span.float-right 
                        //-     a(@click="addAccount('Income')") {{ $t('Products.__AddNewAccount') }}
                    AccountSelector(
                        v-if="item.incomeTag",
                        :key="nowTime",
                        v-model="item.incomeAccountId",
                        :rules="item.incomeTag ? [rules.required] : []"
                    )
                    //- .field-label 
                    //-     span {{ $t('Products.__Purchase') }}
                    //- v-checkbox(
                    //-     v-model="item.expenseTag",
                    //-     :label="$t('Products.__IsBuyingItem')"
                    //- )
                    .field-label(v-if="item.expenseTag")
                        span {{ $t('Products.__ExpenseAccount') }}
                        span.required *
                        //- span.float-right 
                        //-     a(@click="addAccount('OperatingCosts')") {{ $t('Products.__AddNewAccount') }}
                    AccountSelector(
                        v-if="item.expenseTag",
                        :key="nowTime + 1",
                        v-model="item.expenseAccountId",
                        :rules="item.expenseTag ? [rules.required] : []"
                    )

            v-card-actions.justify-center.mb-6
                v-btn.mr-6(rounded dark @click="cancelEditDialog" color="lightGray" width='112') {{$t('ActionOption.__Cancel')}}
                v-btn(rounded dark @click="saveEdit" color="primary" width='112') {{$t('ActionOption.__Save')}}
</template>

<script>
import * as textfieldUtils from "@/utils/textfield.js"

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    editType: {
      type: Number,
      default: 1
    },
    item: {
      type: Object,
      default: function() {
        return {}
      }
    },
    category: {
      type: String,
      default: ""
    },
    doneAction: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      formValid: false,
      rules: textfieldUtils.rules,
      nowTime: Date.now()
    }
  },
  methods: {
    saveEdit() {
      this.$refs.productform.validate()
      if (this.formValid) {
        if (this.editType == 1) {
          this.createProduct()
        } else {
          this.updateProduct()
        }
      }
    },
    createProduct() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("products/createProduct", this.item)
        .then(
          function(response) {
            this.doneAction(response.data.productId)

            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyCreated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
      this.cancelEditDialog()
    },
    updateProduct() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("products/updateProduct", this.item)
        .then(
          function(response) {
            this.doneAction()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyUpdated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
      this.cancelEditDialog()
    },
    cancelEditDialog() {
      this.$emit("input", false)
      this.$refs.productform.resetValidation()
      this.$refs.productform.reset()
    }
  },
  created() {
    if (this.category == "buy") {
      this.item.expenseTag = true
    } else if (this.category == "sell") {
      this.item.incomeTag = true
    } else {
      this.item.incomeTag = true
      this.item.expenseTag = true
    }
  }
}
</script>
